module.exports = __webpack_public_path__ + "static/img/program.2cad49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2024/galaxy_award/program.png
// module id = dQyE
// module chunks = 0